/**
 * 按需引入lodash
 * 已配置webpack&babelrc
 * lodash 4.16.1 文档： http://www.css88.com/doc/lodash/
 * @type Object
 */
/**
 * 微信小程序引入lodash不能正常工作
 * https: //www.nestattacked.com/2017/08/19/weixin-application-tostring-bug/
 */
// Function.prototype.toString = Object.getPrototypeOf(function () {});

import _ from 'lodash';

export default {
    clone: _.clone,
    cloneDeep: _.cloneDeep,
    isInteger: _.isInteger, //检查 value 是否为一个整数。
    uniq: _.uniq, //去重
    debounce: _.debounce,
    throttle: _.throttle,
    each: _.each,
    last: _.last, //获取array中的最后一个元素。
    size: _.size,
    add: _.add,
    subtract: _.subtract,
    trim: _.trim,
    assign: _.assign,
    map: _.map,
    values: _.values,
    keys: _.keys,
    isEmpty: _.isEmpty,
    isObject: _.isObject,
    isString: _.isString,
    isArray: _.isArray,
    compact: _.compact, // 创建一个新数组，包含原数组中所有的非假值元素。例如false, null, 0, "", undefined, 和 NaN 都是被认为是“假值”。
    indexOf: _.indexOf,
    uniqBy: _.uniqBy
};
